import {
  AccessTime,
  AppsOutage,
  CloudQueueOutlined,
  Dashboard,
  ExpandLess,
  ExpandMore,
  Notifications,
} from '@mui/icons-material';
import {
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Collapse,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useIsAdmin } from 'features/auth/hooks/useIsAdmin';
import { useEffect, useState } from 'react';
import { useSystemModules } from 'features/systemModules/api/getSystemModules';
import { StyledDrawerList } from './StyledDrawerList';

interface Props {
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const AlarmsList = ({ drawerOpen, setDrawerOpen }: Props) => {
  const isAdmin = useIsAdmin();

  const [alarmsOpen, setAlarmsOpen] = useState(false);
  const [alarmWallsOpen, setAlarmWallsOpen] = useState(false);

  const { data: modules } = useSystemModules({});

  const handleAlarmsClick = () => {
    setAlarmsOpen(!alarmsOpen);
    setDrawerOpen(true);
  };

  const handleAlarmWallsClick = () => {
    setAlarmWallsOpen((state) => !state);
    setDrawerOpen(true);
  };

  useEffect(() => {
    if (!drawerOpen) {
      setAlarmsOpen(false);
      setAlarmWallsOpen(false);
    }
  }, [drawerOpen]);

  return (
    <StyledDrawerList sx={{ padding: 0 }}>
      <ListItemButton component={Link} to='/' key={'Dashboard'}>
        <ListItemIcon>
          <Dashboard />
        </ListItemIcon>
        <ListItemText primary={'Dashboard'} />
      </ListItemButton>
      <ListItemButton onClick={handleAlarmsClick}>
        <ListItemIcon>
          <Notifications />
        </ListItemIcon>
        <ListItemText primary='Alarms' />
        {alarmsOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={alarmsOpen} timeout='auto' unmountOnExit>
        {isAdmin && (
          <ListItemButton component={Link} to='/snapshot-alarm-setup'>
            <ListItemText primary='Setup' />
          </ListItemButton>
        )}

        <ListItemButton component={Link} to='/alarm-log'>
          <ListItemText primary='Log' />
        </ListItemButton>
      </Collapse>

      <ListItemButton onClick={handleAlarmWallsClick}>
        <ListItemIcon>
          <AppsOutage />
        </ListItemIcon>
        <ListItemText primary='Alarm Walls' />
        {alarmWallsOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={alarmWallsOpen} timeout='auto' unmountOnExit>
        <ListItemButton component={Link} to='/alarm-wall-history'>
          <ListItemText primary='History' />
        </ListItemButton>

        <ListItemButton component={Link} to='/alarm-wall-live'>
          <ListItemText primary='Live' />
        </ListItemButton>
      </Collapse>
      <ListItemButton component={Link} to='/time-warning-log'>
        <ListItemIcon>
          <AccessTime />
        </ListItemIcon>
        {drawerOpen ? (
          <ListItemText primary='Time Warnings' />
        ) : (
          <ListItemText primary='Link' />
        )}
      </ListItemButton>
      {modules?.WEATHER && isAdmin && (
        <ListItemButton component={Link} to='/weatheralerts'>
          <ListItemIcon>
            <CloudQueueOutlined />
          </ListItemIcon>
          <ListItemText primary='Weather' />{' '}
        </ListItemButton>
      )}
    </StyledDrawerList>
  );
};

export default AlarmsList;
